<template>
  <div class="section-new-order">
    <div class="col-8 col-lg-8 col-xl-5 mx-auto py-xl-2">
      <div>
        <h3 class="section-title-centered text-uppercase" v-translate>Time</h3>
        <div class="row">
          <div class="form-group col-sm-6">
            <label for="timeStart" v-translate>Start time</label>
            <datetime
              type="datetime"
              input-class="form-control"
              format="dd/MM/yyyy HH:mm"
              v-model="timeStart"
            />
          </div>
          <div class="form-group col-sm-6">
            <label for="timeEnd" v-translate>End time</label>
            <datetime
              type="datetime"
              input-class="form-control"
              format="dd/MM/yyyy HH:mm"
              v-model="timeEnd"
            />
          </div>
        </div>

        <div class="button-footer text-center pt-4">
          <button class="btn btn-primary px-4" @click="onConfirm" v-translate>Submit</button>
          <button class="btn btn-default px-4 ml-2" @click="onCancel" v-translate>Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BillService from '@/services/BillService';

export default {
  name: 'ChangeTime',
  data() {
    return {
      timeStart: null,
      timeEnd: null,
    };
  },
  computed: {
    selectedItem() { return this.getMap('selectedItem', true) },
    ...mapState({
      bill: state => state.bill.bill,
    }),
    ...mapGetters(['getCommissionOfItem', 'getDatetime', 'getTimerArticleQty', 'getTimerArticleTotal']),
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'order' });
    },
    async onConfirm() {
      this.selectedItem.timeStart = this.getDatetime(this.timeStart);
      this.selectedItem.timeEnd = this.getDatetime(this.timeEnd);
      this.selectedItem.qty = this.getTimerArticleQty(this.selectedItem);
      this.selectedItem.total = this.getTimerArticleTotal(this.selectedItem);

      if (this.selectedItem.id) {
        const updatedItems = [this.selectedItem];
        const commission = this.getCommissionOfItem(this.selectedItem, 'old');
        if (commission) {
          updatedItems.push(commission);
        }

        const billData = Object.assign({}, this.bill, { billItems: updatedItems });
        await BillService.post(billData);
      }

      this.$router.push({ name: 'order' });
    },
    getISOString(date) {
      return date ? new Date(date.replace(' ', 'T')).toISOString() : null;
    },
  },
  mounted() {
    if (this.selectedItem && !this.selectedItem.empty) {
      this.timeStart = this.getISOString(this.selectedItem.timeStart);
      this.timeEnd = this.getISOString(this.selectedItem.timeEnd);
    } else {
      this.$router.push({ name: 'order' });
    }
  },
};
</script>

<style lang="scss" scoped>
  .confirm-modal {
    text-align: center;
    padding: 1rem 1.5rem;
  }
</style>
